
























































import { DraftCompanyParams } from '@/store/interfaces/drafts';
import drafts from '@/store/types/drafts';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import InboundCard from './inboundCard.vue';
import DescriptionValue from '@/components/Reusable/descriptionValue.vue';
import CommerceForm from './forms/commerce.vue';
import commerceKind from '@/store/types/commerceKind';
import { VuexFunction } from '@/ts/axios';
import { CommerceKindParams } from '@/store/interfaces/commerceKind';
import { responseDataPagination } from '@/store/interfaces/json-api/generics';
import imagePreview from '@/components/Reusable/imagePreview.vue';

type tImage = {
  id: number;
  src: string;
  type: string;
  text: string;
};
@Component({
  components: { InboundCard, DescriptionValue, CommerceForm, imagePreview, },
})
export default class Commerces extends Vue {
  edit = false;
  isLoadingCommerceKind = true;

  images: tImage[] = [
    {
      id: 1,
      src: 'banner_url',
      type: 'banner',
      text: 'Banner',
    },
    {
      id: 2,
      src: 'logo_url',
      type: 'logo',
      text: 'Logo',
    },
    {
      id: 3,
      src: 'merchant_logo_url',
      type: 'merchant_logo',
      text: 'Merchant',
    }
  ];

  editThrows(value: boolean): void {
    this.edit = value;
  }

  async mounted(): Promise<void> {
    await this.commerceKindList();
    this.isLoadingCommerceKind = false;
  }

  @Getter(`drafts/${drafts.getters.GET_DRAFT_COMPANY}`)
  draftCompany!: DraftCompanyParams;

  @Action(
    `commerceModule/commerceKind/${commerceKind.actions.LIST_COMMERCE_KIND}`
  )
  commerceKindList!: VuexFunction<CommerceKindParams[]>;

  @Getter(
    `commerceModule/commerceKind/${commerceKind.getters.GET_COMMERCE_KIND}`
  )
  getCommerceKindList!: responseDataPagination<CommerceKindParams[]>;
}
